import {
  ContentBlock,
  Mention
} from "@v2/components/form/MentionTextarea/types";

export const contentBlocksToText = (
  blocks: ContentBlock[]
): { text: string; mentions: Mention[] } => {
  let text = "";
  const mentions: Mention[] = [];

  blocks.forEach((block) => {
    const start = text.length;

    if (block.type === "text") {
      text += block.text || "";
    } else if (block.type === "user") {
      const value = `@${block.label || ""}`;
      text += value;
      mentions.push({
        start,
        end: start + value.length,
        value,
        trigger: "@",
        id: block.id,
        label: block.label
      });
    } else if (block.type === "channel") {
      const value = `#${block.label || ""}`;
      text += value;
      mentions.push({
        start,
        end: start + value.length,
        value,
        trigger: "#",
        id: block.id,
        label: block.label
      });
    } else if (block.type === "command") {
      const value = `/${block.label || ""}`;
      text += value;
      mentions.push({
        start,
        end: start + value.length,
        value,
        trigger: "/",
        id: block.id,
        label: block.label
      });
    }
  });

  return { text, mentions };
};

export const textToContentBlocks = (
  text: string,
  mentions: Mention[]
): ContentBlock[] => {
  const blocks: ContentBlock[] = [];
  let lastIndex = 0;

  const sortedMentions = [...mentions].sort((a, b) => a.start - b.start);

  sortedMentions.forEach((mention) => {
    if (mention.start > lastIndex) {
      blocks.push({
        type: "text",
        text: text.substring(lastIndex, mention.start)
      });
    }

    const type =
      mention.trigger === "@"
        ? "user"
        : mention.trigger === "#"
          ? "channel"
          : "command";
    blocks.push({
      type,
      id: mention.id,
      label: mention.label || mention.value.substring(1)
    });

    lastIndex = mention.end;
  });

  if (lastIndex < text.length) {
    blocks.push({
      type: "text",
      text: text.substring(lastIndex)
    });
  }

  return blocks;
};
